import React from 'react';

import useGetRequest from 'src/hooks/useGetRequest';
import CardList from './CardList';

const HttpCardList = ({
  url,
  processResult,
  ...props
}: any) => {
  const { result, isLoading, httpRequest } = useGetRequest({
    url,
    initialResult: [],
    processResult,
  });

  return (
    <CardList
      objects={result}
      isLoading={isLoading}
      httpRequest={httpRequest}
      {...props}
    />
  );
};

export default HttpCardList;
